import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";

import Aside from "../aside";
import TablePreloader from "../../../assets/preloaders/TablePreloader";

import { getPreDataService } from "../../../../services/registerApi";
import { getUserRequests } from "../../../../services/userService";
import { toggleSidebar } from "../../../../store/actions/layout";
import { showErrorMessage } from "../../../../services/httpService";

const Requests = () => {
   const dispatch = useDispatch();
   const navigate = useNavigate();
   const { isSidebarOpened } = useSelector((state) => state.layout);
   const listRef = useRef();

   const [loading, setLoading] = useState(true);
   const [section, setSection] = useState(1);
   const [showReqList, setShowReqList] = useState(false);
   const [reqTypes, setReqTypes] = useState([]);
   const [requests, setRequests] = useState([]);

   const handelAddReq = (e) => {
      setShowReqList(false);
      if (e.target.textContent === "ثبت فروشگاه") {
         navigate("/store");
      }
   };

   useEffect(() => {
      window.scrollTo(0, 0);
      const close = (e) => {
         if (listRef.current && !listRef.current.contains(e.target)) {
            setShowReqList(false);
         }
      };

      const getData = async () => {
         let res = await getUserRequests();
         if (res.error) {
            showErrorMessage(res);
         } else {
            setRequests(res.data);
         }

         res = await getPreDataService("requests");
         if (res.error) {
            showErrorMessage(res);
         } else {
            setReqTypes(res.data.requestTypes);
         }
         setLoading(false);
      };
      getData();

      document.body.addEventListener("click", close);
      return () => document.body.removeEventListener("click", close);
   }, []);


   return (
      <section className="container">
         <div className="container__row">
            <Aside />
            <main
               className="main__container main__container--orders"
               onClick={() => isSidebarOpened && dispatch(toggleSidebar())}
            >
               <div className="tabbar">
                  <div
                     className="tab"
                     style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}
                  >
                     <div>
                        <button className={section === 1 ? "tablinks active" : "tablinks"}>
                           ثبت فروشگاه
                        </button>
                     </div>
                     <div className="add-req__btn" ref={listRef}>
                        <img
                           src="/img/plus.svg"
                           style={{ width: "1.3rem", height: "auto" }}
                           onClick={() => {
                              setShowReqList(prev => !prev);
                           }}
                        />
                        {showReqList &&
                           <ul className="add-req__list">
                              <li onClick={handelAddReq}>ثبت فروشگاه</li>
                           </ul>
                        }
                     </div>
                  </div>

                  <div className="tabcontent" style={{ display: "block" }}>
                     {loading ? (
                        <TablePreloader />
                     ) : (
                        requests.length === 0 ?
                           <p style={{ textAlign: 'center', fontSize: '1.5rem', paddingTop: '3rem' }}>
                              درخواستی وجود ندارد
                           </p> :
                           requests?.map((req, index) => {
                              return (
                                 <div className="cards__search-result" key={index}>
                                    <div className="cards__header">
                                       <span>{req.typeTitle}</span>
                                       <span className="cards__situation-one">
                                          {req.statusTitle}
                                       </span>
                                    </div>
                                    <div className="cards__body">
                                       <div>
                                          <div className="cards__order">
                                             <span className="cards__order-title">
                                                نام فروشگاه :
                                             </span>
                                             <span className="cards__order-item">
                                                {req.details.storeName}
                                             </span>
                                          </div>
                                          <div className="cards__order">
                                             <span className="cards__order-title">
                                                نوع فروشگاه :
                                             </span>
                                             <span className="cards__order-item">
                                                {req.details.storeType}
                                             </span>
                                          </div>
                                       </div>
                                       <div>
                                          <div className="cards__order">
                                             <span className="cards__order-title">نام مدیر :</span>
                                             <span className="cards__order-item">
                                                {req.details.managerName}
                                             </span>
                                          </div>
                                          <div className="cards__order">
                                             <span className="cards__order-title">
                                                نوع همکاری :
                                             </span>
                                             <span className="cards__order-item">
                                                {req.details.cooperationType}
                                             </span>
                                          </div>
                                       </div>

                                       <Link
                                          // onClick={(e) => {
                                          //    e.preventDefault();
                                          // }}
                                          to={`/request-details/${req.requestId}`}
                                          className="cards__btn"
                                       >
                                          <span>جزییات بیشتر</span>
                                          <img src="/img/arrow.png" alt="details" />
                                       </Link>
                                    </div>
                                 </div>
                              );
                           })
                     )}
                  </div>
               </div>
            </main>
         </div >
      </section >
   );
};

export default Requests;
